<template>
  <div class="login">
    <div class="login-box">
      <div class="login-bg"></div>
      <div class="login-input">
        <h2>登录</h2>
        <a-form :form="form" @submit.prevent="handleSubmit">
          <a-form-item v-bind="formItemLayout" label="">
            <a-input v-decorator="['username', decoratorOptions.username]" size="large" placeholder="请输入账号">
              <a-icon slot="prefix" type="user"/>
            </a-input>
          </a-form-item>

          <a-form-item v-bind="formItemLayout" label="">
            <a-input-password v-decorator="['password', decoratorOptions.password]" type="password" size="large" placeholder="请输入密码">
              <a-icon slot="prefix" type="lock"/>
            </a-input-password>
          </a-form-item>

          <a-form-item class="captcha" v-bind="formItemLayout" label="">
            <a-input v-decorator="['captcha', decoratorOptions.captcha]" size="large" placeholder="请输入验证码">
              <a-icon slot="prefix" type="global"/>
            </a-input>
            <div @click="getCaptcha" class="img-box">
              <img :src="captchaUrl" alt="">
            </div>
          </a-form-item>

          <a-form-item class="submit-btn" :wrapper-col="{ span: 19 }">
            <a-button type="primary" html-type="submit" block size="large">登录</a-button>
          </a-form-item>
          <span @click="$router.push({name: 'forget'})" class="forget">忘记密码？</span>
        </a-form>
      </div>
    </div>
    <div class="record">
      <a href="http://www.beian.miit.gov.cn" target="_blank"><p>闽ICP备17026099号</p></a>
    </div>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.appAuth],
  name: 'login',
  data () {
    return {
      imgkey: '',
      captchaUrl: '',
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 19 }
      },
      decoratorOptions: {
        username: {
          rules: [{ required: true, message: '请输入账号' }]
        },
        password: {
          rules: [{ required: true, message: '请输入密码' }]
        },
        captcha: {
          rules: [{ required: true, message: '请输入验证码' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.getCaptcha();
  },
  methods: {
    /* 获取验证码 */
    getCaptcha () {
      this.$get({
        url: '/get_captcha_src',
        params: {}
      }).then(({data}) => {
        this.captchaUrl = `${data.img}`;
        this.imgkey = data.imgkey;
      });
    },
    /* 提交登录 */
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        values = {...values, imgkey: this.imgkey};
        this.$post({
          url: '/signin',
          params: values
        }).then(({data}) => {
          localStorage.userToken = data.user_token;
          let userInfo = {
            avatar_url: data.avatar_url,
            user_name: data.user_name,
            mobile: data.mobile,
            role_desc: data.role_desc,
            true_name: data.true_name,
            sex: data.sex
          };
          this.setLocal('userInfo', userInfo);
          let admin = data['is_super_admim'];

          if (admin === 1) {
            this.setLocal('adminStatus', `${admin}`);
            this.$router.addRoutes(this.$store.state.routes);

            this.$message.success('登录成功！').then((res) => {
              this.handleRoute(1, this.$store.state.menuList);
            });
          } else {
            let menu = this.handleAuth(data.auth.views);
            this.$message.success('登录成功！').then((res) => {
              let len = menu.length;
              if (len) {
                if (len === 1) {
                  this.handleRoute(0, menu);
                } else if (len > 1) {
                  if (menu[0].key !== 'dataView') {
                    this.handleRoute(0, menu);
                  } else {
                    this.handleRoute(1, menu);
                  }
                }
              } else {
                this.$router.push({name: 'noAuth'});
              }
            });
          }
        });
      });
    },
    /* 处理跳转路由 */
    handleRoute (menuIndex, menu) {
      if (menuIndex > 0) {
        this.$store.commit('setActiveIndex', {
          openKeys: [`${menuIndex}`],
          selectedKeys: [`${menuIndex}-0`]
        });
      }
      this.$router.push({name: menu[menuIndex].subMenu[0].route});
    },
    /* 处理权限 */ // 路由修改后，角色需重新提交
    handleAuth (auth) {
      let authc = auth.c;
      let authFull = [...authc, ...auth.h];

      let routeList = [];
      authFull.forEach((el) => {
        this.$store.state.routes.forEach((item) => {
          // 三层:{key: route_组件名}
          let key = el.split('_');
          if (key.length === 2) {
            var name = key[1];
          }
          let noExist = routeList.every(eve => eve.name !== item.name);
          if (name === item.name && noExist) {
            routeList.push({...item});
          }
        });
      });

      let btnList = [];
      authc.forEach((el) => {
        // * 四层：{title: 路由btnlist title, key: 路径_btnlist key}
        let key = el.split('_');
        if (key.length === 2) {
          var path = key[0];
          let btnKey = key[1];
          this.$store.state.routes.forEach((item) => {
            if (item.path === path) {
              item.btnList.forEach((part) => {
                if (part.key === btnKey) {
                  let btnObj = {...part};
                  btnObj.componentName = item.name;
                  btnList.push(btnObj);
                }
              });
            }
          });
        }
      });

      let menuList = [];
      // * 第一层{key: 主菜单key}
      // * 第二层： {key: 组件名}
      this.$store.state.menuList.forEach((item) => {
        authFull.forEach((el) => {
          let noExist = menuList.every(eve => eve.key !== item.key);
          if (el === item.key && noExist) {
            let menuItem = {...item};
            menuItem.subMenu = [];
            menuList.push(menuItem);
          }
        });
      });

      let subMenuArr = [];
      this.$store.state.menuList.forEach((item) => {
        item.subMenu.forEach((part) => {
          authFull.forEach((el) => {
            let noExist = subMenuArr.every(eve => eve.route !== part.route);
            if (el === part.route && noExist) {
              subMenuArr.push({...part});
            }
          });
        });
      });

      menuList.forEach((el) => {
        subMenuArr.forEach((item) => {
          if (item.key === el.key) {
            el.subMenu.push({...item});
          }
        });
      });

      this.setLocal('routeList', routeList);
      this.setLocal('btnList', btnList);
      this.setLocal('menuList', menuList);
      this.setMenuRoute(menuList, routeList);
      return menuList;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/login.vue